import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  NewServiceBus,
  ServiceBusConfiguration,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.seller}adapterServiceBusConfigurations`;

export interface SetServiceBusConfigurationArgs extends ServiceBusConfiguration {
  sellerId: string;
  renewKeys?: boolean;
}

export default async function setServiceBusConfiguration(
  payload: SetServiceBusConfigurationArgs,
): Promise<BackResponse<NewServiceBus> | BackResponseFailure> {
  try {
    const response = await apiCall<BackResponse<NewServiceBus>>(ENDPOINT, {
      method: SUPPORTED_METHODS.PUT,
      json: payload,
    });

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
}
